import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button } from 'reactstrap';
import { injectIntl } from 'react-intl';

import {
  refreshCollections,
  setCollectionFilters,
  setCollectionsParams,
  clearAllCollectionFiltersAndReload,
} from '../../actions/Collections';

import {
  collectionFilterParams,
  filterParams,
  handleComponentParams,
  handleURLParams,
  handleURLParamsClear,
  searchFilterParams,
} from '../../helpers/URLParams';

import FiltersCollectionDates from './FiltersCollectionDates';
import FiltersCollectionVisibility from './FiltersCollectionVisibility';
import FiltersCollectionUsers from './FiltersCollectionUsers';
import FiltersPinnedSearches from './FiltersPinnedSearches';
import FiltersSearch from './FiltersSearch';

class SidebarCollectionFilters extends Component {
  constructor(props) {
    super(props);

    this.handleChangeFilters = this.handleChangeFilters.bind(this);
    this.resetFiltersWrapper = this.resetFiltersWrapper.bind(this);
  }

  componentDidMount() {
    const { updateFilters, location } = this.props;

    const searchParams = new URLSearchParams(location.search);

    if (searchParams.toString() !== '') {
      handleComponentParams(
        true,
        collectionFilterParams,
        null,
        this.setState.bind(this),
        (updatedFilters) => {
          updateFilters(updatedFilters);
        },
      );
    }
  }

  componentDidUpdate(prevProps) {
    const { updateFilters, location } = this.props;

    if (location.pathname === '/files' || location.pathname === '/collections') {
      handleComponentParams(
        false,
        collectionFilterParams,
        prevProps,
        this.setState.bind(this),
        (updatedFilters) => {
          updateFilters(updatedFilters);
        },
      );
    }
  }

  handleChangeFilters(changedFilters) {
    const { updateFilters, history } = this.props;
    handleURLParams(changedFilters, history);
    updateFilters(changedFilters);
  }

  resetFiltersWrapper() {
    const { resetFilters, history } = this.props;
    handleURLParamsClear([...filterParams, ...searchFilterParams], history);
    resetFilters();
  }

  render() {
    const {
      intl,
      availableFilters,
      selectedFilters,
    } = this.props;

    return (
      <div>
        <div className="filters-header">
          <h5 className="filters-title">
            <i className="far fa-sliders-h" />
            {intl.formatMessage({ defaultMessage: 'Filters' })}
          </h5>
          <Button
            color="link"
            className="action-clear action-clear-all"
            onClick={this.resetFiltersWrapper}
          >
            {intl.formatMessage({ defaultMessage: 'Clear all' })}
          </Button>
        </div>
        <div className="files-filters">
          <FiltersSearch type="collections" />
          <FiltersPinnedSearches
            handleReset={this.resetFiltersWrapper}
            handleChangeFilters={this.handleChangeFilters}
            selectedFilters={selectedFilters}
            type="collections"
          />
          <FiltersCollectionVisibility
            availableFilters={availableFilters.visibility}
            handleChangeFilters={this.handleChangeFilters}
          />
          <FiltersCollectionUsers
            handleChangeFilters={this.handleChangeFilters}
          />
          <FiltersCollectionDates
            handleChangeFilters={this.handleChangeFilters}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  availableFilters: state.Collections.availableFilters,
  selectedFilters: state.Collections.selectedFilters,
});

const mapDispatchToProps = dispatch => ({
  updateFilters: (updatedFilters) => {
    dispatch(setCollectionFilters(updatedFilters));
    dispatch(setCollectionsParams({ page: 0 }));
    dispatch(refreshCollections());
  },
  resetFilters: () => {
    dispatch(clearAllCollectionFiltersAndReload());
  },
});

SidebarCollectionFilters.propTypes = {
  intl: PropTypes.object.isRequired,
  availableFilters: PropTypes.object.isRequired,
  selectedFilters: PropTypes.array.isRequired,
  updateFilters: PropTypes.func.isRequired,
  resetFilters: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

export default withRouter(
  injectIntl(connect(mapStateToProps, mapDispatchToProps)(SidebarCollectionFilters)),
);
